import { Component, HostListener, OnInit } from '@angular/core';
import { COLLEGE_RECON_CONSTANTS } from 'src/app/constants';
import {
  CollegeService,
} from 'src/app/services';
import { BrowserService, CryptoService } from 'src/app/core';
import { DataService } from 'src/app/services/data-link.service';
import { storageUtil } from 'src/app/utils';
import { groupBy, filter, debounce } from 'src/app/utils/lodash-utility';

@Component({
  selector: 'admin-layout',
  templateUrl: './admin-layout.component.html',
})
export class AdminLayoutComponent implements OnInit {
  user: any;
  isBrowser: any;
  sidebarVisible: boolean = true;
  resizeListener: any;

  constructor(
    private _storageUtil: storageUtil,
    private _cryptoService: CryptoService,
    private _dataLinkService: DataService,
    private _collegeService: CollegeService,
    private _browserService: BrowserService,
  ) {}

  ngOnInit(): void {
    this.isBrowser = this._browserService.checkBrowser();
    if (this.isBrowser && window.screen.width <= 810) {
      // 810 portrait
      this.sidebarVisible = false;
    }
    this.resizeListener = debounce(() => {
      this.checkScreenWidth();
    }, 200)

    if (this.isBrowser) {
      const encryptedData = this._storageUtil.getItem('loggedInUser');
      this.user =
        encryptedData &&
        this._cryptoService.decryptData(
          encryptedData,
          COLLEGE_RECON_CONSTANTS.userEncryptDecryptSecretKey,
        );
      this.user = JSON.parse(this.user);
      this._dataLinkService.setUser(this.user);

      this.getInboxCount();
    }
  }

  ngOnDestroy(): void {
    this.isBrowser && window.removeEventListener('resize', this.resizeListener);
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.checkScreenWidth();
  }

  checkScreenWidth(): void {
    if (this.isBrowser && window.screen.width > 810) {
      this.sidebarVisible = true;
    }
  }

  getInboxCount() {
    this._collegeService.getInboxMessageCount(this.user.collegeId).subscribe({
      next: (res) => {
        this._dataLinkService.setInboxCount(res.countinbox);
      },
      error: (e) => console.log(e),
    });
  }

  closeCallback(): void {
    this.sidebarVisible = false;
  }
}
